import React, {FC, useCallback, useEffect} from 'react';
import {Paper, Table, TableCell, TableContainer, TableHead, TableRow, TableBody} from '@mui/material';
import {Order, StudentFilter, StudentInterface, StudentOrderBy} from '../../interfaces';
import ManageStudentsTableHead from "./ManageStudentsTableHead";
import ManageStudentsTableRow from "./ManageStudentsTableRow";
import {useTranslation} from "../../services";
interface ManageStudentsTableInterface {
	data: StudentInterface[];
	filter: StudentFilter;
	onFilterChange: (value: StudentFilter | object) => void;
	hidden: boolean;
}

const ManageStudentsTable: FC<ManageStudentsTableInterface> = ({
	data,
	onFilterChange,
	filter,
	...props
}) => {
    const { t } = useTranslation();
    const [order, setOrder] = React.useState<Order>(filter.order || Order.ASC);
    const [orderBy, setOrderBy] = React.useState<StudentOrderBy | undefined>(
        filter.orderBy
    );

    const handleRequestSort = useCallback(
        (
            event: React.MouseEvent<unknown>,
            property: StudentOrderBy | undefined
        ) => {
            const isAsc = orderBy === property && order === Order.ASC;
            setOrder(isAsc ? Order.DESC : Order.ASC);
            setOrderBy(property);
        },
        [order, orderBy, setOrder, setOrderBy]
    );

    useEffect(() => {
        onFilterChange({ order, orderBy });
    }, [order, orderBy]);
	return (
		<>
			<TableContainer component={Paper} {...props}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <ManageStudentsTableHead
                                title="Unit"
                                columnName={StudentOrderBy.UNIT}
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                            />
                            <ManageStudentsTableHead
                                title="Student ID"
                                order={order}
                                columnName={StudentOrderBy.ID}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                            />
                            <ManageStudentsTableHead
                                title="Email"
                                order={order}
                                columnName={StudentOrderBy.EMAIL}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                            />
                            <ManageStudentsTableHead
                                title="Name"
                                order={order}
                                columnName={StudentOrderBy.NAME}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                                />
                            <ManageStudentsTableHead
                                title="Status"
                                order={order}
                                columnName={StudentOrderBy.STATUS}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                            />
                            <ManageStudentsTableHead
                                title="Date / Time of change"
                                order={order}
                                columnName={StudentOrderBy.UPDATED_AT}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                            />
                            <TableCell>{t('Description')}</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row) => (<ManageStudentsTableRow key={row.id} row={row} />))}
                    </TableBody>
                </Table>
            </TableContainer>
		</>
	);
};

export default ManageStudentsTable;
